import LogoIcon from '../../assets/images/logo-50x50.svg';
import * as React from 'react';
import { Component } from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import Input from '../../components/Input';
import Select from '../../components/Select';
import { connect } from 'react-redux';
import Textarea from '../../components/Textarea';
import { enableAutosave } from '../../redux/actions/general/autosave';
import { __, dateFrom, getLocalized } from '../../core/utils';
import DateTimePicker from '../../components/DateTimePicker';
import Tooltip from '../../components/Tooltip';
import ArrowDownSmallIcon from '../../assets/images/arrow-down-small-15x15.svg';
import Checkbox from '../../components/Checkbox';
import styles from '../../../src/styles/forms/substages/EditSubstageForm.scss';
import classNames from 'classnames';
import Localization from '../../helpers/Localization';
import { subscribe } from 'react-contextual';
import * as _ from 'lodash';
import WarningIcon from '../../assets/images/tender-icon-warning-16x16.svg';
import { listPlanningLibraryItems } from '../../redux/actions/table/planning_library';

const mapStateToProps = (state) => {
  return {
    values: getFormValues('substages.details')(state),
    auth: state.auth,
  };
};

@reduxForm({
  form: 'substages.details',
  enableReinitialize: true,
})
@connect(mapStateToProps)
@subscribe(Localization, 'localization')
class EditSubstageForm extends Component {
  state = {
    planningLibraryItems: [],
  };

  componentDidMount() {
    listPlanningLibraryItems('substage', false, true).then(({ response }) => {
      this.setState({
        planningLibraryItems: _.map(
          response.data,
          (item) => ({
            value: item.id,
            label: [
              getLocalized(item.name, this.props.auth.language_id),
              item.code,
            ].filter(Boolean).join(' - '),
            icon: (
              <Tooltip
                text={item.is_system
                  ? __('planning-templates.source.system')
                  : __('planning-templates.source.my-company')}
              >
                <span
                  className={classNames(
                    styles.planningTemplateSource,
                    item.is_system ? styles.systemSource : styles.companySource,
                  )}
                >
                  {item.is_system ? <LogoIcon /> : 'MY'}
                </span>
              </Tooltip>
            ),
          })
        ),
      });
    });
  }

  UNSAFE_componentWillReceiveProps() {
    enableAutosave(this.props.form);
  }

  render() {
    // const stage_statuses = [
    //   {
    //     value: 1,
    //     label: __('project-settings.stages.flyout.status.not-started'),
    //   },
    //   {
    //     value: 2,
    //     label: __('project-settings.stages.flyout.status.started'),
    //   },
    //   {
    //     value: 3,
    //     label: __('project-settings.stages.flyout.status.finished'),
    //   },
    // ];

    const stage_statuses = [
      {
        value: 'not-started',
        label: __('stages.status.not-started'),
        color: '#9C27B0',
      },
      {
        value: 'started',
        label: __('stages.status.started'),
        color: '#5777FC',
      },
      {
        value: 'finished',
        label: __('stages.status.finished'),
        color: '#ADD42B',
      },
      {
        value: 'closed',
        label: __('stages.status.closed'),
        color: '#009688',
      },
      {
        value: 'reopened',
        label: __('stages.status.reopened'),
        color: '#303F9F',
      },
      {
        value: 'canceled',
        label: __('stages.status.canceled'),
        color: '#CCCDD1',
      },
    ];

    const status =
      _.get(this.props.values, 'status') ||
      _.get(this.props.initialValues, 'status');
    const disabled = !this.props.isProjectAdministrator || status === 'canceled';
    const isFinished = _.includes(['finished', 'closed'], status);
    const isDeadline = _.get(this.props.values, 'date.deadline') === 1;
    const hasDates =
      !!_.get(this.props.values, 'date.start') &&
      !!_.get(this.props.values, 'date.end');

    const deadline_date =
      _.get(this.props.values, 'date.deadline_date') ||
      _.get(this.props.initialValues, 'date.deadline_date');
    const deadline_date_formatted =
      deadline_date && dateFrom(deadline_date, true);

    return (
      <Form onSubmit={this.props.handleSubmit}>
        {/* <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='status'
              component={Select}
              label={__('project-settings.stages.flyout.status')}
              options={stage_statuses}
              noSort
              dropdown
              wrapper={(handleOpen, activeItem, elementRef) => (
                <Tooltip text={__('project-settings.stages.flyout.status')}>
                  <div
                    className={styles.dropdown}
                    ref={elementRef}
                    style={{ background: activeItem.color }}
                    onClick={handleOpen}
                  >
                    <div className={styles.button}>
                      {activeItem.label}
                      <ArrowDownSmallIcon />
                    </div>
                  </div>
                </Tooltip>
              )}
            />
          </div>
          <div className={styles.f1} />
        </div> */}
        {/* <Field
          disabled={!this.props.isProjectAdministrator}
          name='date'
          component={DateTimePicker}
          label={__('project-settings.substages.flyout.date-range')}
          footer
          range
        /> */}
        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              disabled={disabled}
              // localized={this.props.application_languages}
              localized={this.props.projectLanguages}
              name='name'
              component={Input}
              label={__('project-settings.substages.flyout.title')}
              maxLength={50}
            />
          </div>
          <div className={styles.f1}>
            <Field
              disabled={disabled}
              name='substage_template_id'
              component={Select}
              noSort
              searchable
              label={__('project-settings.substages.flyout.template')}
              options={this.state.planningLibraryItems}
            />
          </div>
        </div>
        <Field
          disabled={disabled}
          // localized={this.props.application_languages}
          localized={this.props.projectLanguages}
          name='description'
          component={Textarea}
          label={__('project-settings.substages.flyout.description')}
          maxLength={100}
          rows={1}
          maxRows={10}
        />
        <div className={styles.flex}>
          {deadline_date_formatted && (
            <div className={styles.deadlineIndicator}>
              <Tooltip text={deadline_date_formatted}>
                <span className={styles.deadlineIconBox}>
                  <WarningIcon className={styles.deadlineIcon} />
                </span>
              </Tooltip>
            </div>
          )}
          <div className={styles.f2}>
            <Field
              disabled={disabled}
              name='date'
              component={DateTimePicker}
              label={__('substages.flyout.date-range')}
              footer
              range
              lockEndDate={isDeadline}
            />
          </div>
          <div className={classNames(styles.f1, styles.duration)}>
            <Field
              name='date.duration'
              component={Input}
              label={__('substages.flyout.duration')}
              placeholder={__('substages.flyout.enter-duration')}
              disabled={isDeadline || disabled || !hasDates}
            />
          </div>
          <div className={classNames(styles.f1, styles.deadline)}>
            <div className={styles.deadlineLabel}>
              {__('substages.flyout.deadline')}
            </div>
            <Field
              name='date.deadline'
              component={Checkbox}
              // label={__('deadline')}
              className={styles.checkbox}
              onChange={(event) => {}}
              disabled={disabled}
            />{' '}
          </div>
          <div className={classNames(styles.f1, styles.estimate)}>
            <Field
              name='time_log.planned_time'
              component={Input}
              label={__('substages.flyout.planned-time')}
              placeholder={__('substages.flyout.enter-planned-time')}
              disabled={disabled}
            />
          </div>
        </div>
        {isFinished && (
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='finished_at'
                component={DateTimePicker}
                label={__('project-planning.finish-date')}
                footer
              />
            </div>
            <div className={styles.f1} />
          </div>
        )}
        {/* <Field
          disabled={!this.props.isProjectAdministrator}
          name='status'
          component={Select}
          label={__('project-settings.substages.flyout.status')}
          options={stage_statuses}
        /> */}
      </Form>
    );
  }
}

export default EditSubstageForm;
